//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, tool, commonData } from "@/mixins/index";
import phoneEdit from "./components/phoneEdit";
import associationAccount from "./components/associationAccount.vue";
export default {
  name: "phoneLogin",
  mixins: [loadMoreList, tool, commonData],
  components: {
    phoneEdit: phoneEdit,
    associationAccount: associationAccount
  },
  data: function data() {
    return {
      paramsData: {
        isMustAppid: 1
      },
      pagingReqFn: "phoneList",
      columns: []
    };
  },
  created: function created() {},
  activated: function activated() {
    this.getcommonData(['appListAllData']);
  },
  methods: {
    exportDataFn: function exportDataFn() {
      this.columns = [{
        label: '用户ID',
        prop: 'user_id'
      }, {
        label: '网关用户ID',
        prop: 'gate_user_id'
      }, {
        label: '电话',
        prop: 'phone'
      }, {
        label: '创建时间',
        prop: 'create_time'
      }];
      this.exportData();
    }
  }
};